export default __webpack_public_path__ + "static/media/regulatory--two-way--g1.b64bf0c5.png";